'use client';

import { useMount } from 'react-use';
import fireAnalytics from '~/services/analytics/fireAnalytics';

export default function SupermodelPageAnalytics({
  landerId,
  landerName,
}: {
  landerId: number;
  landerName: string;
}) {
  useMount(() => {
    fireAnalytics('Visited Super Model', null, {
      lander_id: landerId,
      name: landerName,
    });
  });

  return null;
}
